<template>
  <div>
    <transition name="dashboard">
      <div class="main-div">
        <h1>{{ title }}</h1>
        <v-row class="mt-10">
          <v-col md="6" sm="12" style="border: 5px solid;">
            <v-autocomplete
              v-model="selectedProduct"
              :items="resource.product"
              item-text="name"
              return-object
              label="Produk"
              :loading="loadingProduct"
            ></v-autocomplete>
            <v-row style=" max-width: 50%;">
              <v-col cols="6">
                <h4>Jenis</h4>
              </v-col>
              <v-col cols="6"> : {{ selectedProduct.type }} </v-col>
            </v-row>
            <v-row style=" max-width: 50%;">
              <v-col cols="6">
                <h4>Tarif Iuran</h4>
              </v-col>
              <v-col cols="6">
                : <span v-show="selectedProduct.due_year"> {{ selectedProduct.due_year }} %</span>
              </v-col>
            </v-row>
            <v-row style=" max-width: 50%;">
              <v-col cols="6">
                <h4>Jangka Waktu</h4>
              </v-col>
              <v-col cols="6">
                :
                <span v-show="selectedProduct.due_max"
                  >{{ selectedProduct.due_min }} Bulan - {{ selectedProduct.due_max }} Bulan</span
                >
              </v-col>
            </v-row>
            <v-row style=" max-width: 50%;">
              <v-col cols="6">
                <h4>Batas Plafond</h4>
              </v-col>
              <v-col cols="6">
                :
                <span v-show="selectedProduct.plafond_max"
                  >{{ getCurrency(selectedProduct.plafond_max) }}
                </span>
              </v-col>
            </v-row>
          </v-col>

          <v-col md="6" sm="12" style="border: 5px solid;">
            <v-row class="ml-2">
              <h3>Isi Data dibawah ini</h3>
              <v-icon class="blink ml-5" v-bind="attrs" v-on="on">mdi-information</v-icon>
            </v-row>
            <v-row style="max-width: 50%;">
              <v-col cols="6" class="d-flex align-center">
                <h4>Plafond</h4>
              </v-col>
              <v-col cols="6">
                <v-currency-field v-model="input.plafond" @keyup="calculateSubscription"></v-currency-field>
              </v-col>
            </v-row>
            <v-row style="max-width: 50%;">
              <v-col cols="6" class="d-flex align-center">
                <h4>Jangka Waktu</h4>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  @keypress="onlyNumber"
                  id="periode"
                  v-model="input.periode"
                  suffix="Bulan"
                  dense
                  class="detail-input__input-text"
                  required
                  :loading="loading"
                  @keyup="calculateSubscription()"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="d-flex justify-center align-center class my-15 ">
            <v-row style="max-width: 50%;">
              <v-col cols="6" class="d-flex align-center">
                <h1 :style="{ fontSize: $vuetify.breakpoint.mdAndUp ? '5em' : '1.5em' }">Iuran</h1>
              </v-col>
              <v-col cols="6">
                <h1 :style="{ fontSize: $vuetify.breakpoint.mdAndUp ? '5em' : '1.5em' }">
                  {{ getCurrency(input.tariff.nominal) }}
                </h1>
              </v-col>
            </v-row>
          </v-col>
          <v-col>
            <div>
              <v-alert
                class="d-flex justify-center"
                dense
                transition="scale-transition"
                :value="alert"
                :type="alertType"
              >
                {{ this.alertTitle }}
                <br v-if="this.alertTitle != ''" />
                <div class="d-flex justify-center">{{ this.alertMessage }}</div>
              </v-alert>
            </div>
          </v-col>
        </v-row>
      </div>
    </transition>
  </div>
</template>
<script>
import Swal from 'sweetalert2'
import Constant from '@/const'

import ConstantMixin from '@/constantMixin'
import { get } from 'lodash'

const _ = require('lodash')
const axios = require('axios')
const moment = require('moment')

export default {
  mixins: [ConstantMixin],
  data: () => ({
    title: 'Simulasi Iuran Peserta',
    loading: false,
    input: {
      id_product: '',
      plafond: '',
      disbursement: '',
      periode: '',
      due_date: '',
      tariff: {
        percent: 0,
        nominal: 0
      }
    },
    alert: false,
    alertType: 'success',
    alertMessage: 'ok',
    alertTitle: '',
    selectedProduct: {
      name: '',
      type: ''
    },
    resource: {
      product: []
    }
  }),
  computed: {
    disbursementFormattedMomentjs() {
      return this.input.disbursement
        ? moment(this.input.disbursement)
            .locale('id')
            .format('D MMMM YYYY')
        : ''
    },
    dueFormattedMomentjs() {
      return this.input.due_date
        ? moment(this.input.due_date)
            .locale('id')
            .format('D MMMM YYYY')
        : ''
    }
  },
  async mounted() {
    this.getProduct()
    this.alertMsg()
  },
  watch: {
    selectedProduct: {
      handler(newVal) {
        this.alertMsg()
      },
      deep: true
    },
    input: {
      handler(newVal) {
        this.alertMsg()
      },
      deep: true
    }
  },
  methods: {
    setAlert(alert, type, msg, title) {
      this.alertType = type
      this.alert = alert
      this.alertMessage = msg
      this.alertTitle = title || ''
    },
    alertMsg() {
      this.setAlert(false, 'success', 'Simulasi Iuran Sesuai')
      if (!this?.selectedProduct?.name) return this.setAlert(true, 'info', 'Pilih Produk')
      else {
        if (!this.input.periode) return this.setAlert(true, 'info', 'Isi Jangka Waktu')
        else {
          if (this.input.periode < this.selectedProduct.due_min)
            return this.setAlert(true, 'error', `Jangka Waktu Minimal ${this.selectedProduct.due_min} Bulan`)
          if (this.input.periode > this.selectedProduct.due_max)
            return this.setAlert(true, 'error', `Jangka Waktu Maksimal ${this.selectedProduct.due_max} Bulan`)
        }
      }

      if (!this.input.plafond) return this.setAlert(true, 'info', 'Isi Plafond')
      else {
        if (this.input.plafond < this.selectedProduct.plafond_min)
          return this.setAlert(
            true,
            'error',
            `Plafond Minimal ${this.getCurrency(this.selectedProduct.plafond_min)}`
          )
        if (this.input.plafond > this.selectedProduct.plafond_max)
          return this.setAlert(
            true,
            'error',
            `Plafond Maksimal ${this.getCurrency(this.selectedProduct.plafond_max)}`
          )
      }
    },
    calculateSubscription() {
      if (this.input.periode && this.input.plafond) {
        this.input.tariff.percent = this.selectedProduct.due_year
        this.input.tariff.nominal = Math.round(
          this.input.plafond * (this.input.periode / 100) * this.selectedProduct.due_year
        )
      }
      if (this.input.disbursement && this.input.periode) {
        this.input.due_date = moment(this.input.disbursement)
          .add(this.input.periode, 'month')
          .format()
      }
    },
    getProduct() {
      this.loadingProduct = true
      axios.get(Constant.apiUrl.concat('/product/active?sort=code')).then(response => {
        if (response.status === 200) {
          const resData = response.data.data

          this.resource.product = resData.map(r => {
            return r
          })
          this.loadingProduct = false
        } else {
          this.resource.product = []
          this.loadingProduct = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-enter {
  opacity: 0;
  transform: translateX(-100px);
}
.dashboard-leave-to {
  opacity: 0;
  transform: translateX(100px);
}
.dashboard-enter-active {
  transition: all 0.3s ease-in;
}

.autocomplete {
  max-width: 14%;
  margin-right: 2%;
}
.main-div {
  margin: 10px auto;
  width: 90%;
}

h1 {
  font-size: 1.5em;
  text-align: left;
}

.search {
  // display: flex;
  // position: relative;
  // align-items: center;
  // justify-content: flex-start;
  right: 0;
}

.input {
  max-width: 30%;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
}

.blink {
  animation: blink-animation 1s steps(5, start) infinite;
  -webkit-animation: blink-animation 1s steps(5, start) infinite;
}
@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
@-webkit-keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
</style>
